import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';

import EdSectionFolderIcon from '@/courses/components/ed-section-folder-icon/ed-section-folder-icon.vue';
import EdFolderItemProgress from '../ed-folder-item-progress/ed-folder-item-progress.component.vue';
import { COURSE_EVENTS } from '@/content/values/events';

@Component({
  components: {
    EdSectionFolderIcon,
    EdFolderItemProgress
  }
})
export default class EdFolderItemComponent extends Vue {
  
  @Prop() readonly folderIconName: string;
  @Prop() readonly folderIconOpenName: string;
  @Prop() readonly selected: boolean;
  @Prop() readonly name: string;
  @Prop() readonly subtitle: string;
  @Prop() readonly opened: boolean;
  @Prop() readonly level: number;
  @Prop() readonly hasEditionIcons: boolean;
  @Prop() readonly loading: boolean;
  @Prop() readonly isVisible: boolean;
  @Prop() readonly menuEditOptions: any[];
  @Prop() readonly menuAddOptions: any[];
  @Prop() readonly isSelectable: boolean;
  @Prop() readonly titleId: string;
  @Prop() readonly showTeacherOnly: boolean;
  @Prop() readonly section: any;
  @Prop({default: false}) isDeck: boolean;
  @Prop({default: false}) isLink: boolean;
  @Prop({default: false}) hideOptions: boolean;


  readonly onSelect: string = 'onSelect';
  readonly onOpen: string = 'onOpen';
  readonly onEditDeck: string = 'onEditDeck';
  readonly onRemoveDeck: string = 'onRemoveDeck';
  readonly onVisibleTriggered: string = 'onVisibleTriggered';
  readonly onMenuEditOptionSelected: string = 'onMenuEditOptionSelected';
  readonly onMenuAddOptionSelected: string = 'onMenuAddOptionSelected';
  disableAddMenu: boolean = false;

  @Emit('onAdd')
  onAdd() {
    return;
  }

  get progressColor() {
    return this.selected ? 'var(--ed-color-gray-lighter)' : 'var(--ed-color-green)';
  }

  get containerStyles() {
    const paddingLeft = `edg-pad-left--${this.level == 1 ? this.level * 10 : this.level * 10}`;
    return { 
      'ed-section-folder--selected': this.selected,
      [paddingLeft]: true,
      'disabled': this.loading,
    }
  }

  get deckCounterMsg(){
    let msg = String(this.$i18n.t('deck.cardCounter'));
    return msg.replace('{{cards}}', String(this.section?.sections?.length));
  }

  get disableAddMenuBySectionStatus() {
    return this.section.sectionStatus === 'PROCESSING' || this.section.sectionStatus === 'ERROR' || this.disableAddMenu;
  }

  get menuEditOptionsFiltered() {
    if(!this.disableAddMenuBySectionStatus) {
      return this.menuEditOptions;
    } 
    return this.menuEditOptions.filter(m => m.type === COURSE_EVENTS.REMOVE_SECTION);
  }

  uploadProgessItemByStatus(sectionStatus) {
    if(sectionStatus && sectionStatus === 'PROCESSING' || sectionStatus === 'ERROR') {
      this.disableAddMenu = true;
    } else {
      this.disableAddMenu = false;
    }
  }

  toggleOpened() {
    if(!this.disableAddMenuBySectionStatus) {
      this.$emit(this.onOpen);
      if(this.isDeck) {
        this.$emit(this.onEditDeck);
      }
    }
  }

  triggerSelect() {
    if(!this.disableAddMenuBySectionStatus) {
      if(this.isDeck && this.isSelectable) {
        this.$emit(this.onOpen);
        this.$emit(this.onEditDeck);
        return
      }
  
      if(this.isSelectable) {
        this.$emit(this.onSelect);
        if(!this.opened){
          this.$emit(this.onOpen);
        }
      }
    }
  }

  async triggerVisible() {
    this.$emit(this.onVisibleTriggered);
  }

  async triggerAdd(optionSelected) {
    this.$emit(this.onMenuAddOptionSelected, optionSelected);
  }

  async selectEditOption(optionSelected) {
    this.$emit(this.onMenuEditOptionSelected, optionSelected);
  }

  @Watch('section.sectionStatus')
  updateSectionStatus(sectionStatus) {
    this.uploadProgessItemByStatus(sectionStatus);
  }

  removeDeck() {
    this.$emit(this.onRemoveDeck);
  }

}

